export const finanzamtMap: Map<number, string> = new Map<number, string>([
  [1010, 'Saarlouis'],
  [1020, 'Merzig'],
  [1030, 'Neunkirchen'],
  [1040, 'Saarbrücken I'],
  [1055, 'Saarbrücken II'],
  [1060, 'St. Wendel'],
  [1075, 'Homburg'],
  [1085, 'Homburg - Außenst. St. Ingbert'],
  [1113, 'Charlottenburg'],
  [1114, 'Friedrichshain-Kreuzberg'],
  [1115, 'Berlin International'],
  [1116, 'Neukölln'],
  [1117, 'Reinickendorf'],
  [1118, 'Schöneberg'],
  [1119, 'Spandau'],
  [1120, 'Steglitz'],
  [1121, 'Tempelhof'],
  [1123, 'Wedding'],
  [1124, 'Wilmersdorf'],
  [1125, 'Zehlendorf'],
  [1127, 'für Körperschaften I'],
  [1129, 'für Körperschaften III'],
  [1130, 'für Körperschaften IV'],
  [1131, 'Prenzlauer Berg'],
  [1132, 'Lichtenberg'],
  [1133, 'Marzahn-Hellersdorf'],
  [1134, 'Mitte/Tiergarten'],
  [1135, 'Pankow/Weißensee'],
  [1136, 'Treptow-Köpenick'],
  [1137, 'für Körperschaften II'],
  [1138, 'für Fahndung und Strafsachen Berlin'],
  [2111, 'Bad Segeberg'],
  [2113, 'Elmshorn'],
  [2115, 'Flensburg'],
  [2116, 'Dithmarschen'],
  [2117, 'Nordfriesland'],
  [2118, 'Itzehoe'],
  [2120, 'Kiel'],
  [2122, 'Lübeck'],
  [2124, 'Neumünster'],
  [2125, 'Ostholstein'],
  [2126, 'Plön'],
  [2127, 'Ratzeburg'],
  [2128, 'Rendsburg'],
  [2129, 'Eckernförde-Schleswig'],
  [2130, 'Stormarn'],
  [2131, 'Pinneberg'],
  [2137, 'Zentrale Prüfungsdienste'],
  [2171, 'Bad Segeberg Bewertung für Grundsteuer 71'],
  [2172, 'Eckernförde-Schleswig Bewertung für Grundsteuer 72'],
  [2173, 'Elmshorn Bewertung für Grundsteuer 73'],
  [2175, 'Flensburg Bewertung für Grundsteuer 75'],
  [2176, 'Dithmarschen Bewertung für Grundsteuer 76'],
  [2177, 'Nordfriesland Bewertung für Grundsteuer 77'],
  [2178, 'Itzehoe Bewertung für Grundsteuer 78'],
  [2179, 'Kiel Bewertung für Grundsteuer 79'],
  [2180, 'Kiel Bewertung für Grundsteuer 80'],
  [2181, 'Nordfriesland Bewertung für Grundsteuer 81'],
  [2182, 'Lübeck Bewertung für Grundsteuer 82'],
  [2183, 'Dithmarschen Bewertung für Grundsteuer 83'],
  [2184, 'Neumünster Bewertung für Grundsteuer 84'],
  [2185, 'Ostholstein Bewertung für Grundsteuer 85'],
  [2186, 'Plön Bewertung für Grundsteuer 86'],
  [2187, 'Ratzeburg Bewertung für Grundsteuer 87'],
  [2188, 'Rendsburg Bewertung für Grundsteuer 88'],
  [2189, 'Eckernförde-Schleswig Bewertung für Grundsteuer 89'],
  [2190, 'Stormarn Bewertung für Grundsteuer 90'],
  [2191, 'Pinneberg Bewertung für Grundsteuer 91'],
  [2210, 'Hamburg für Verkehrst. und Grundbesitz (10)'],
  [2216, 'Hamburg für Verkehrst. und Grundbesitz (16)'],
  [2217, 'Hamburg-Nord (17)'],
  [2220, 'Hamburg für Verkehrst. und Grundbesitz (20)'],
  [2227, 'Hamburg für Großunternehmen in Hamburg'],
  [2228, 'Hamburg für Prüfungsd. und Strafsachen'],
  [2235, 'Hamburg für Verkehrst. und Grundbesitz (35)'],
  [2241, 'Hamburg-Altona'],
  [2242, 'Hamburg-Am Tierpark'],
  [2243, 'Hamburg-Barmbek-Uhlenhorst'],
  [2244, 'Hamburg-Ost (44)'],
  [2245, 'Hamburg-Eimsbüttel'],
  [2246, 'Hamburg-Hansa'],
  [2247, 'Hamburg-Harburg'],
  [2248, 'Hamburg-Mitte'],
  [2249, 'Hamburg-Nord (49)'],
  [2250, 'Hamburg-Oberalster'],
  [2251, 'Hamburg-Ost (51)'],
  [2313, 'Braunschweig-Helmstedt'],
  [2314, 'Braunschweig-Wilhelmstraße'],
  [2315, 'Buchholz in der Nordheide'],
  [2316, 'Burgdorf'],
  [2317, 'Celle'],
  [2318, 'Cuxhaven'],
  [2319, 'Gifhorn'],
  [2320, 'Göttingen'],
  [2321, 'Goslar-Bad Gandersheim'],
  [2322, 'Hameln-Holzminden'],
  [2323, 'Hannover-Land I'],
  [2324, 'Hannover-Mitte'],
  [2325, 'Hannover-Nord'],
  [2326, 'Hannover-Süd'],
  [2327, 'Hannover-Land II'],
  [2328, 'Helmstedt'],
  [2330, 'Hildesheim-Alfeld'],
  [2333, 'Lüneburg'],
  [2334, 'Nienburg/Weser'],
  [2335, 'Northeim-Herzberg am Harz'],
  [2336, 'Osterholz-Scharmbeck'],
  [2338, 'Peine'],
  [2340, 'Rotenburg (Wümme)'],
  [2341, 'Soltau'],
  [2343, 'Stade'],
  [2344, 'Stadthagen'],
  [2345, 'Sulingen'],
  [2346, 'Syke'],
  [2347, 'Uelzen-Lüchow'],
  [2348, 'Verden  / Aller'],
  [2349, 'Wesermünde'],
  [2350, 'Winsen / Luhe'],
  [2351, 'Wolfenbüttel'],
  [2352, 'Zeven'],
  [2353, 'Papenburg'],
  [2354, 'Aurich-Wittmund'],
  [2355, 'Bad Bentheim'],
  [2356, 'Cloppenburg'],
  [2357, 'Delmenhorst'],
  [2358, 'Emden-Norden'],
  [2360, 'Leer / Ostfriesland'],
  [2361, 'Lingen / Ems'],
  [2363, 'Nordenham'],
  [2364, 'Oldenburg (Oldb)'],
  [2365, 'Osnabrück-Land'],
  [2366, 'Osnabrück-Stadt'],
  [2367, 'Quakenbrück'],
  [2368, 'Vechta'],
  [2369, 'Westerstede'],
  [2370, 'Wilhelmshaven'],
  [2390, 'für Fahndung und Strafsachen Braunschweig'],
  [2391, 'Hannover für Fahndung und Strafsachen'],
  [2392, 'Lüneburg für Fahndung und Strafsachen'],
  [2393, 'Oldenburg für Fahndung und Strafsachen'],
  [2457, 'Bremerhaven Bewertung Bremen'],
  [2460, 'Bremen'],
  [2475, 'Bremerhaven'],
  [2477, 'Bremerhaven Bewertung'],
  [2601, 'Alsfeld-Lauterbach Verwaltungsstelle Alsfeld'],
  [2602, 'Hersfeld-Rotenburg Verwaltungsstelle Bad Hersfeld'],
  [2603, 'Bad Homburg vor der Höhe'],
  [2604, 'Rheingau-Taunus'],
  [2605, 'Bensheim'],
  [2606, 'Marburg-Biedenkopf Verwaltungsstelle Biedenkopf'],
  [2607, 'Darmstadt'],
  [2608, 'Dieburg'],
  [2609, 'Dillenburg'],
  [2610, 'Werra-Meißner Verwaltungsstelle Eschwege'],
  [2611, 'Korbach-Frankenberg Verwaltungsstelle Frankenberg'],
  [2614, 'Frankfurt am Main (014)'],
  [2616, 'Friedberg (Hessen)'],
  [2618, 'Fulda'],
  [2619, 'Gelnhausen'],
  [2620, 'Gießen'],
  [2621, 'Groß-Gerau'],
  [2622, 'Hanau'],
  [2623, 'Kassel (023)'],
  [2624, 'Schwalm-Eder Verwaltungsstelle Fritzlar'],
  [2625, 'Kassel (025)'],
  [2626, 'Kassel (026)'],
  [2627, 'Korbach-Frankenberg Verwaltungsstelle Korbach'],
  [2628, 'Langen'],
  [2629, 'Alsfeld-Lauterbach Verwaltungsstelle Lauterbach'],
  [2630, 'Limburg-Weilburg'],
  [2631, 'Marburg-Biedenkopf Verwaltungsstelle Marburg'],
  [2632, 'Schwalm-Eder Verwaltungsstelle Melsungen'],
  [2633, 'Michelstadt'],
  [2634, 'Nidda'],
  [2636, 'Hersfeld-Rotenburg Verwaltungsstelle Rotenburg'],
  [2637, 'Rheingau-Taunus (Grundstücksbewertung)'],
  [2638, 'Limburg-Weilburg (Grundstücksbewertung)'],
  [2639, 'Wetzlar'],
  [2640, 'Wiesbaden (040)'],
  [2641, 'Werra-Meißner Verwaltungsstelle Witzenhausen'],
  [2642, 'Schwalm-Eder Verwaltungsstelle Schwalmstadt'],
  [2644, 'Offenbach am Main (044)'],
  [2645, 'Frankfurt am Main (045)'],
  [2646, 'Hofheim am Taunus'],
  [2701, 'Bad Neuenahr-Ahrweiler'],
  [2702, 'Altenkirchen-Hachenburg'],
  [2706, 'Bad Kreuznach'],
  [2708, 'Bingen-Alzey'],
  [2709, 'Idar-Oberstein'],
  [2710, 'Bitburg-Prüm'],
  [2719, 'Kaiserslautern'],
  [2722, 'Koblenz'],
  [2723, 'Kusel-Landstuhl'],
  [2724, 'Landau'],
  [2726, 'Mainz'],
  [2727, 'Ludwigshafen'],
  [2729, 'Mayen'],
  [2730, 'Montabaur-Diez'],
  [2731, 'Neustadt'],
  [2732, 'Neuwied'],
  [2734, 'Kusel-Landstuhl für Erb/Schenk.St. Saarland'],
  [2735, 'Pirmasens'],
  [2740, 'Simmern-Zell'],
  [2741, 'Speyer-Germersheim'],
  [2742, 'Trier'],
  [2743, 'Wittlich'],
  [2744, 'Worms-Kirchheimbolanden'],
  [2801, 'Offenburg -01- (vormals ASt Achern)'],
  [2804, 'Villingen-Schwenningen Außenstelle Donaueschingen'],
  [2805, 'Emmendingen'],
  [2806, 'Freiburg-Stadt'],
  [2807, 'Freiburg-Land'],
  [2808, 'Offenburg Außenstelle Kehl'],
  [2809, 'Konstanz'],
  [2810, 'Lahr'],
  [2811, 'Lörrach'],
  [2812, 'Müllheim'],
  [2813, 'Freiburg-Land Außenstelle Titisee-Neustadt'],
  [2814, 'Offenburg -14-'],
  [2815, 'Rottweil Außenstelle Oberndorf'],
  [2816, 'Waldshut-Tiengen Außenstelle Bad Säckingen'],
  [2818, 'Singen'],
  [2819, 'Rottweil'],
  [2820, 'Waldshut-Tiengen'],
  [2821, 'Tuttlingen'],
  [2822, 'Villingen-Schwenningen'],
  [2823, 'Offenburg Außenstelle Wolfach'],
  [2830, 'Bruchsal'],
  [2831, 'Ettlingen'],
  [2832, 'Heidelberg'],
  [2833, 'Baden-Baden'],
  [2834, 'Karlsruhe-Durlach'],
  [2835, 'Karlsruhe-Stadt'],
  [2836, 'Baden-Baden Außenstelle Bühl'],
  [2837, 'Mannheim-Neckarstadt'],
  [2838, 'Mannheim-Stadt'],
  [2839, 'Rastatt'],
  [2840, 'Mosbach'],
  [2841, 'Pforzheim'],
  [2842, 'Freudenstadt'],
  [2843, 'Schwetzingen'],
  [2844, 'Sinsheim'],
  [2845, 'Calw'],
  [2846, 'Mosbach Außenstelle Walldürn'],
  [2847, 'Weinheim'],
  [2848, 'Mühlacker'],
  [2849, 'Pforzheim Außenstelle Neuenbürg'],
  [2850, 'Aalen'],
  [2851, 'Backnang'],
  [2852, 'Tauberbischofsheim Außenstelle Bad Mergentheim'],
  [2853, 'Balingen'],
  [2854, 'Biberach'],
  [2855, 'Bietigheim-Bissingen'],
  [2856, 'Böblingen'],
  [2857, 'Schwäbisch Hall Außenstelle Crailsheim'],
  [2858, 'Ehingen'],
  [2859, 'Esslingen'],
  [2861, 'Friedrichshafen'],
  [2862, 'Göppingen Außenstelle Geislingen'],
  [2863, 'Göppingen'],
  [2864, 'Heidenheim'],
  [2865, 'Heilbronn'],
  [2869, 'Nürtingen Außenstelle Kirchheim'],
  [2870, 'Leonberg'],
  [2871, 'Ludwigsburg'],
  [2874, 'Nürtingen'],
  [2876, 'Öhringen'],
  [2877, 'Ravensburg'],
  [2878, 'Reutlingen'],
  [2879, 'Biberach Außenstelle Riedlingen'],
  [2880, 'Tauberbischofsheim'],
  [2881, 'Sigmaringen Außenstelle Bad Saulgau'],
  [2882, 'Schorndorf'],
  [2883, 'Schwäbisch Gmünd'],
  [2884, 'Schwäbisch Hall'],
  [2885, 'Sigmaringen'],
  [2886, 'Tübingen'],
  [2887, 'Überlingen (Bodensee)'],
  [2888, 'Ulm'],
  [2889, 'Bad Urach'],
  [2890, 'Waiblingen'],
  [2891, 'Wangen'],
  [2892, 'Stuttgart IV'],
  [2893, 'Stuttgart I'],
  [2895, 'Stuttgart II'],
  [2896, 'Stuttgart Zentrales Konzernprüfungsamt'],
  [2897, 'Stuttgart III'],
  [2899, 'Stuttgart-Körpersch.'],
  [3046, 'Potsdam'],
  [3048, 'Brandenburg'],
  [3049, 'Königs Wusterhausen'],
  [3050, 'Luckenwalde'],
  [3051, 'Nauen'],
  [3052, 'Kyritz'],
  [3053, 'Oranienburg'],
  [3056, 'Cottbus'],
  [3057, 'Calau'],
  [3061, 'Frankfurt (Oder)'],
  [3062, 'Angermünde'],
  [3064, 'Strausberg'],
  [3065, 'Eberswalde'],
  [3102, 'Magdeburg'],
  [3103, 'Genthin'],
  [3105, 'Haldensleben'],
  [3106, 'Salzwedel'],
  [3107, 'Staßfurt'],
  [3108, 'Stendal'],
  [3110, 'Halle (Saale)'],
  [3112, 'Merseburg'],
  [3114, 'Dessau-Roßlau'],
  [3115, 'Wittenberg'],
  [3116, 'Bitterfeld-Wolfen'],
  [3117, 'Quedlinburg'],
  [3118, 'Eisleben'],
  [3119, 'Naumburg'],
  [3202, 'Dresden-Nord'],
  [3203, 'Dresden-Süd'],
  [3204, 'Bautzen'],
  [3207, 'Görlitz'],
  [3208, 'Löbau'],
  [3209, 'Meißen'],
  [3210, 'Pirna'],
  [3213, 'Hoyerswerda'],
  [3214, 'Chemnitz-Süd'],
  [3215, 'Chemnitz-Mitte'],
  [3217, 'Annaberg'],
  [3218, 'Schwarzenberg'],
  [3220, 'Freiberg'],
  [3222, 'Mittweida'],
  [3223, 'Plauen'],
  [3224, 'Stollberg'],
  [3227, 'Zwickau'],
  [3228, 'Zschopau'],
  [3231, 'Leipzig II'],
  [3232, 'Leipzig I'],
  [3236, 'Döbeln'],
  [3237, 'Eilenburg'],
  [3238, 'Grimma'],
  [3239, 'Oschatz'],
  [4070, 'Neubrandenburg - RIA (Rentenempfänger im Ausland)'],
  [4072, 'Neubrandenburg'],
  [4075, 'Waren'],
  [4079, 'Rostock'],
  [4080, 'Wismar'],
  [4081, 'Ribnitz-Damgarten'],
  [4082, 'Stralsund'],
  [4084, 'Greifswald'],
  [4086, 'Güstrow'],
  [4087, 'Hagenow'],
  [4090, 'Schwerin'],
  [4151, 'Erfurt'],
  [4154, 'Ilmenau'],
  [4155, 'Eisenach'],
  [4156, 'Gotha'],
  [4157, 'Mühlhausen'],
  [4159, 'Sondershausen'],
  [4161, 'Gera'],
  [4162, 'Jena'],
  [4165, 'Pößneck'],
  [4166, 'Altenburg'],
  [4170, 'Südthüringen (170)'],
  [4171, 'Südthüringen (171)'],
  [5101, 'Dinslaken'],
  [5102, 'Viersen'],
  [5103, 'Düsseldorf-Altstadt'],
  [5105, 'Düsseldorf-Nord'],
  [5106, 'Düsseldorf-Süd'],
  [5107, 'Duisburg-Hamborn'],
  [5109, 'Duisburg-Süd'],
  [5111, 'Essen-NordOst'],
  [5112, 'Essen-Süd'],
  [5113, 'Geldern'],
  [5114, 'Grevenbroich'],
  [5115, 'Kempen'],
  [5116, 'Kleve'],
  [5117, 'Krefeld'],
  [5119, 'Kamp-Lintfort'],
  [5120, 'Mülheim an der Ruhr'],
  [5121, 'Mönchengladbach'],
  [5122, 'Neuss'],
  [5123, 'Oberhausen-Nord'],
  [5124, 'Oberhausen-Süd'],
  [5126, 'Remscheid'],
  [5128, 'Solingen'],
  [5130, 'Wesel'],
  [5131, 'Wuppertal-Barmen'],
  [5132, 'Wuppertal-Elberfeld'],
  [5133, 'Düsseldorf-Mitte'],
  [5134, 'Duisburg-West'],
  [5135, 'Hilden'],
  [5139, 'Velbert'],
  [5147, 'Düsseldorf-Mettmann'],
  [5201, 'Aachen-Stadt'],
  [5202, 'Aachen-Kreis'],
  [5203, 'Bergheim'],
  [5204, 'Bergisch Gladbach'],
  [5205, 'Bonn-Innenstadt'],
  [5206, 'Bonn-Außenstadt'],
  [5207, 'Düren'],
  [5208, 'Erkelenz'],
  [5209, 'Euskirchen'],
  [5210, 'Geilenkirchen'],
  [5211, 'Schleiden'],
  [5212, 'Gummersbach'],
  [5213, 'Jülich'],
  [5214, 'Köln-Altstadt'],
  [5215, 'Köln-Mitte'],
  [5216, 'Köln-Porz'],
  [5217, 'Köln-Nord'],
  [5218, 'Köln-Ost'],
  [5219, 'Köln-Süd'],
  [5220, 'Siegburg'],
  [5221, 'Wipperfürth'],
  [5222, 'Sankt Augustin'],
  [5223, 'Köln-West'],
  [5224, 'Brühl'],
  [5230, 'Leverkusen'],
  [5301, 'Ahaus'],
  [5302, 'Altena'],
  [5303, 'Arnsberg'],
  [5304, 'Beckum'],
  [5305, 'Bielefeld-Innenstadt'],
  [5306, 'Bochum-Mitte'],
  [5307, 'Borken'],
  [5308, 'Bottrop'],
  [5309, 'Brilon'],
  [5310, 'Bünde'],
  [5311, 'Steinfurt'],
  [5312, 'Coesfeld'],
  [5313, 'Detmold'],
  [5314, 'Dortmund-West'],
  [5315, 'Dortmund-Hörde'],
  [5316, 'Dortmund-Unna'],
  [5317, 'Dortmund-Ost'],
  [5319, 'Gelsenkirchen'],
  [5321, 'Hagen'],
  [5322, 'Hamm'],
  [5323, 'Hattingen'],
  [5324, 'Herford'],
  [5325, 'Herne'],
  [5326, 'Höxter'],
  [5327, 'Ibbenbüren'],
  [5328, 'Iserlohn'],
  [5329, 'Lemgo'],
  [5330, 'Lippstadt'],
  [5331, 'Lübbecke'],
  [5332, 'Lüdenscheid'],
  [5333, 'Lüdinghausen'],
  [5334, 'Meschede'],
  [5335, 'Minden'],
  [5336, 'Münster-Außenstadt'],
  [5337, 'Münster-Innenstadt'],
  [5338, 'Olpe'],
  [5339, 'Paderborn'],
  [5340, 'Recklinghausen'],
  [5341, 'Schwelm'],
  [5342, 'Siegen'],
  [5343, 'Soest'],
  [5345, 'Warburg'],
  [5346, 'Warendorf'],
  [5347, 'Wiedenbrück'],
  [5348, 'Witten'],
  [5349, 'Bielefeld-Außenstadt'],
  [5350, 'Bochum-Süd'],
  [5351, 'Gütersloh'],
  [5359, 'Marl'],
  [5380, 'Landesamt zur Bekämpfung der Finanzkriminalität (LBF NRW)'],
  [9101, 'Augsburg-Stadt Arbeitnehmerbereich (101)'],
  [9102, 'Augsburg-Land'],
  [9103, 'Augsburg-Stadt (103)'],
  [9104, 'Wolfratshausen - Bad Tölz (104)'],
  [9105, 'Berchtesgaden-Laufen'],
  [9106, 'Burghausen'],
  [9107, 'Dachau'],
  [9108, 'Deggendorf'],
  [9109, 'Dillingen'],
  [9110, 'Dingolfing'],
  [9111, 'Nördlingen mit ASt Donauwörth (111)'],
  [9112, 'Ebersberg'],
  [9113, 'Eggenfelden'],
  [9114, 'Erding'],
  [9115, 'Freising'],
  [9117, 'Fürstenfeldbruck'],
  [9119, 'Garmisch-Partenkirchen'],
  [9121, 'Günzburg'],
  [9123, 'Kempten-Immenstadt (123)'],
  [9124, 'Ingolstadt'],
  [9125, 'Kaufbeuren m. ASt Füssen'],
  [9126, 'Kelheim'],
  [9127, 'Kempten-Immenstadt (127)'],
  [9131, 'Landsberg am Lech'],
  [9132, 'Landshut'],
  [9134, 'Lindau'],
  [9138, 'Memmingen-Mindelheim (138)'],
  [9139, 'Miesbach'],
  [9140, 'Memmingen-Mindelheim (140)'],
  [9141, 'Mühldorf'],
  [9142, 'München Bewertung des Grundbesitzes'],
  [9143, 'München (143) Körperschaften/PersonenGesellschaften'],
  [9144, 'München (144) Gewinneinkünfte'],
  [9145, 'München (145) Gewinneinkünfte'],
  [9146, 'München (146) Gewinneinkünfte'],
  [9147, 'München (147) Gewinneinkünfte'],
  [9148, 'München (148) Gewinneinkünfte'],
  [9151, 'Neu-Ulm'],
  [9152, 'Nördlingen mit ASt Donauwörth (152)'],
  [9153, 'Passau mit Außenstellen'],
  [9154, 'Pfaffenhofen'],
  [9156, 'Rosenheim m. ASt Wasserburg'],
  [9157, 'Grafenau'],
  [9159, 'Schrobenhausen m. ASt Neuburg'],
  [9161, 'Starnberg'],
  [9162, 'Straubing'],
  [9163, 'Traunstein'],
  [9168, 'Weilheim-Schongau'],
  [9169, 'Wolfratshausen - Bad Tölz (169)'],
  [9170, 'Zwiesel m. ASt Viechtach'],
  [9171, 'Eichstätt'],
  [9181, 'München (181) Überschusseinkünfte'],
  [9182, 'München (182) Überschusseinkünfte u. Beschränkt Steuerpfl.'],
  [9183, 'München (183) Überschusseinkünfte'],
  [9184, 'München (184) Überschusseinkünfte'],
  [9185, 'München (185) Überschusseinkünfte'],
  [9201, 'Amberg'],
  [9202, 'Obernburg am Main mit Außenstelle Amorbach'],
  [9203, 'Mittelfranken-West (203) (bis 31.12.2025 FA Ansbach mit Außenstellen)'],
  [9204, 'Aschaffenburg'],
  [9205, 'Bad Kissingen'],
  [9206, 'Bad Neustadt a.d.S.'],
  [9207, 'Bamberg'],
  [9208, 'Bayreuth'],
  [9211, 'Cham mit Außenstelle Bad Kötzting'],
  [9212, 'Coburg'],
  [9216, 'Mittelfranken-Ost (216) (bis 31.12.2025 FA Erlangen)'],
  [9217, 'Forchheim'],
  [9218, 'Mittelfranken-West (218) (bis 31.12.2025 FA Fürth)'],
  [9220, 'Mittelfranken-West (220) (bis 31.12.2025 FA Gunzenhausen)'],
  [9221, 'Mittelfranken-Ost (221) (bis 31.12.2025 FA Hersbruck)'],
  [9222, 'Mittelfranken-Ost (222) (bis 31.12.2025 FA Hilpoltstein)'],
  [9223, 'Hof mit Außenstellen'],
  [9227, 'Kitzingen'],
  [9228, 'Kronach'],
  [9229, 'Kulmbach'],
  [9230, 'Lichtenfels'],
  [9231, 'Lohr a. Main mit Außenstellen'],
  [9232, 'Lohr a. Main mit Außenstellen - Grunderwerbsteuer'],
  [9235, 'Neumarkt i.d.Opf.'],
  [9238, 'Nürnberg (238) (bis 31.12.2025 FA Nürnberg-Nord)'],
  [9240, 'Nürnberg (240) (bis 31.12.2025 FA Nürnberg-Süd)'],
  [9241, 'Nürnberg (241) (bis 31.12.2025 FA Nürnberg-Zentral)'],
  [9244, 'Regensburg'],
  [9247, 'Mittelfranken-Ost (247) (bis 31.12.2025 FA Schwabach)'],
  [9248, 'Schwandorf mit Außenstelle Neunburg v. W.'],
  [9249, 'Schweinfurt'],
  [9252, 'Mittelfranken-West (252) (bis 31.12.2025 FA Uffenheim)'],
  [9254, 'Waldsassen'],
  [9255, 'Weiden i.d.Opf.'],
  [9257, 'Würzburg mit Außenstelle Ochsenfurt'],
  [9258, 'Wunsiedel mit Außenstelle Selb'],
  [9259, 'Zeil am Main mit Außenstelle Ebern']
]);
